import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { Print } from "./Print"
import { useMaintenanceModel } from "../maintenanceModel";
import { ScaniaPrints } from "./scaniaPrint"
import { SettleScaniaPrints } from "./settleScaniaPrints"
import { PrintMaintenanceSettle } from "../../view/PrintMaintenanceSettle"
import Item from "antd/lib/descriptions/Item";
import HeaderIcon1 from '../../../../assets/images/index-header-icon1.png'
import HeaderIcon2 from '../../../../assets/images/index-header-icon2.png'
import HeaderIcon3 from '../../../../assets/images/index-header-icon3.png'

export default () => {
    const {
        print,
        scaniaPrint: { visible },
        settleScaniaPrint,
        printSettleVisible, setPrintSettleVisible,
        printParam, descRows, allTotal, setAllTotal
    } = useMaintenanceModel();
    return (
        <>
            <div style={{
                display: 'flex',
                height: '50px',
            }}>
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    borderRadius: '5px',
                    minWidth: '15.5%',
                    margin: '0 0 0 0',
                    background: 'linear-gradient(135deg, #FF9C27 0%, #F5B013 100%)',
                    padding: '0 20px',
                    position: 'relative' // 新增：相对定位，用于图片绝对定位
                }}>
                    {/* 标题和数据容器 */}
                    <div style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#FFFFFF',
                    }}>全部进厂量</div>
                    <div>
                        <span style={{
                            marginLeft: '8px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#FFFFFF'
                        }}>{allTotal.allInNum}</span>
                    </div>

                    {/* 图片调整到右下角 */}
                    <img
                        src={HeaderIcon1}
                        style={{
                            width: '53px',
                            height: '53px',
                            borderRadius: '50%',
                            position: 'absolute',
                            right: '1px',
                            bottom: '1px'
                        }}
                    />
                </div>

                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px',
                    minWidth: '15.5%',
                    margin: '0 1% 0 1%',
                    background: 'linear-gradient(315deg, #09C3D5 0%, #22B4D8 100%)',
                    padding: '0 20px',
                    position: 'relative'
                }}>
                    <div style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#FFFFFF',
                    }}>全部完工量</div>
                    <div>
                        <span style={{
                            marginLeft: '8px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#FFFFFF'
                        }}>{allTotal.allFinishNum}</span>
                    </div>

                    <img
                        src={HeaderIcon2}
                        style={{
                            width: '53px',
                            height: '53px',
                            borderRadius: '50%',
                            position: 'absolute',
                            right: '1px',
                            bottom: '1px'
                        }}
                    />
                </div>

                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    borderRadius: '5px',
                    minWidth: '15.5%',
                    margin: '0 0 0 0',
                    background: 'linear-gradient(134deg, #FF5252 0%, #FF7954 100%)',
                    padding: '0 20px',
                    position: 'relative'
                }}>
                    <div style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#FFFFFF',
                    }}>全部待处理</div>
                    <div>
                        <span style={{
                            marginLeft: '8px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#FFFFFF'
                        }}>{allTotal.allWaitNum}</span>
                    </div>

                    <img
                        src={HeaderIcon3}
                        style={{
                            width: '53px',
                            height: '53px',
                            borderRadius: '50%',
                            position: 'absolute',
                            right: '1px',
                            bottom: '1px'
                        }}
                    />
                </div>
            </div>


            <PageHeader />
            <DataBox />
            {print && <Print />}
            {visible && <ScaniaPrints />}
            {settleScaniaPrint && <SettleScaniaPrints />}
            {printSettleVisible && <PrintMaintenanceSettle printSettleVisible={printSettleVisible} setPrintSettleVisible={setPrintSettleVisible} printParam={printParam} selectRows={descRows} />}
        </>
    )
}